import {FC, ReactElement} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {LinearProgress} from "@mui/material";
import {useApp2Auth} from "@/app2/auth";

interface IProps {
	children: ReactElement,
}

export const RequireAuth: FC<IProps> = ({children}) => {
	const location = useLocation();
	const {authReady, authenticated, jwt} = useApp2Auth();

	if (!authReady) {
		return <LinearProgress />;
	}

	if (!authenticated || !jwt) {
		return <Navigate to="/" state={{from: location}} />;
	}

	return children;
};
